export default [
  "sl",
  "sl/home",
  "sl/football",
  "sl/football/tips-centre",
  "sl/racing",
  "sl/racing/tips-centre",
  "sl/greyhounds",
  "sl/cricket",
  "sl/darts",
  "sl/golf",
  "sl/rugby-league",
  "sl/rugby-union",
  "sl/tennis",
  "sl/boxing",
  "sl/formula1",
  "sl/snooker",
  "sl/nfl",
  "sl/other-sports"
]



// WEBPACK FOOTER //
// ./utils/baskets.js